/**
 * Cookie Banner
 * 
 * Copyright (c) 2024 Tomasz Dziuda
 * Licensed under the MIT license
 */

/*
 Connections:
 -------------------------------------------------------------------------------
 * google - Google
 * maps - Google Maps
 * 
*/

(function ($) {
    var config = {
        debugMode: true,
        userConsents: {
            google: false,
            maps: false
        },
        userUUID: 'not-set',
        groups: [
            'google',
            'maps'
        ],
        allowedGroups: []
    };
  
    var UI = {
        basicWindow: $('.cn-info'),
        extendedWindow: $('.cn-info-extended'),
        buttons: {
            basicShowExtended: $('.cn-info-button-show-extended'),
            basicAcceptAll: $('.cn-info-button-accept-all'),
            basicRejectAll: $('.cn-info-button-reject-all'),
            extendedAcceptAll: $('.cn-info-extended-button-accept-all'),
            extendedSaveConfig: $('.cn-info-extended-button-save-consent'),
            extendedNotNow: $('.cn-info-extended-button-close-without-save')
        },
        checkboxes: {
            google: $('.cn-consent-checkbox[data-consent-type="google"]'),
            maps: $('.cn-consent-checkbox[data-consent-type="maps"]')
        }
    };
  
    if (UI.basicWindow.length) {
        initEvents();
        initPublicAPI();
        checkConfig(config);
    }
  
    function checkConfig () {
        var configFromCookie = Cookies.get(window.cnConfig.cookieName, { path: window.cnConfig.path });
  
        // When no config - show popup
        if (!configFromCookie) {
            if (config.debugMode) {
                console.log('⛔️ Consent config not found - showing popup');
            }
  
            config.userUUID = generateUUID();

            // Not open on privacy policy page
            if (!$(document.body).hasClass('privacy-policy')) {
                showPopup();
            }

            return;
        }
  
        // otherwise - load config without showing popup
        loadConfig(configFromCookie);
    }
  
    function loadConfig (configFromCookie) {
        config.userConsents.google = configFromCookie.indexOf('google') > -1;
        config.userConsents.maps = configFromCookie.indexOf('maps') > -1;
        let configParts = configFromCookie.split('||');
    
        if (configParts[1]) {
            config.userUUID = configParts[1].replace(/[^a-zA-Z0-9\-]/gmi, '');
        } else {
            config.userUUID = generateUUID();
        }
        
        for (var i = 0; i < config.groups.length; i++) {
            var groupName = config.groups[i];
  
            if (config.userConsents[groupName]) {
                config.allowedGroups.push(groupName);
            }
        }
  
        if (config.debugMode) {
            console.log('⚙️ Founded config:', JSON.parse(JSON.stringify(config.userConsents)));
        }
    }
  
    function initEvents () {
        $(document).find('a[href="#cookie-settings"]').on('click', e => {
            e.preventDefault();
            showExtendedPopup();
        });
  
        UI.buttons.basicShowExtended.on('click', e => {
            e.preventDefault();
            closePopup();
            showExtendedPopup();
        });
  
        UI.buttons.basicAcceptAll.on('click', e => {
            e.preventDefault();
            giveConsentForAll();
            closePopup();
        });
  
        UI.buttons.basicRejectAll.on('click', e => {
            e.preventDefault();
            resetCookieConfig();
            closePopup();
        });
  
        UI.buttons.extendedAcceptAll.on('click', e => {
            e.preventDefault();
            giveConsentForAll();
            closeExtendedPopup();
        });
  
        UI.buttons.extendedSaveConfig.on('click', e => {
            e.preventDefault();
            saveConsent();
            closeExtendedPopup();
        });
  
        UI.buttons.extendedNotNow.on('click', e => {
            e.preventDefault();
            closeExtendedPopup();
            var configFromCookie = Cookies.get(window.cnConfig.cookieName, { path: window.cnConfig.path });
  
            if (!configFromCookie) {
                showPopup();
            }
        });
    }
  
    function setCheckboxes () {
        for (var i = 0; i < config.groups.length; i++) {
            var group = config.groups[i];
  
            if (config.userConsents[group]) {
                UI.checkboxes[group].prop('checked', true);
            } else {
                UI.checkboxes[group].prop('checked', false);
            }
        }
    }
  
    function initPublicAPI () {
        window.cnCookieBanner = {
            giveConsentAndSave: function (type) {
                giveConsentAndSave(type);
            },
            giveConsentAndSaveAndLoad: function (type) {
                giveConsentAndSave(type, true);
            },
            showExtendedPopup: function () {
                showExtendedPopup();
            },
            getConsentStatus: function (type) {
                getConsentStatus(type);
            }
        };
    }
  
    function showPopup () {
        UI.basicWindow.removeClass('is-hidden');
    }
  
    function closePopup () {
        UI.basicWindow.addClass('is-hidden');
    }
  
    function showExtendedPopup () {
        UI.extendedWindow.removeClass('is-hidden');
        $(document.body).addClass('no-scroll');
        setCheckboxes();
    }
  
    function closeExtendedPopup () {
        UI.extendedWindow.addClass('is-hidden');
        $(document.body).removeClass('no-scroll');
    }
  
    function giveConsentForAll () {
        giveConsent('google');
        giveConsent('maps');
        saveConsentConfigInCookie(false);
    }
  
    function giveConsent (type, forceOnLoad = false) {
        if (config.debugMode) {
            console.log('✅ User gave consent:', type);
        }
  
        // If consent has been previously given - do nothing
        if (config.allowedGroups.indexOf(type) > -1) {
            return;
        }
  
        config.userConsents[type] = true;
  
        if (type === 'google') {
            allowGoogle();
            return;
        }

        if (type === 'maps') {
            allowGoogleMaps();
            return;
        }
    }
  
    function giveConsentAndSave (type, forceOnLoad = false) {
        giveConsent(type, forceOnLoad);
        saveConsentConfigInCookie(false);
    }
  
    function saveConsent () {
        var consentCompare = compareConsents();
        setConsentBasedOnCheckboxes();
  
        // if some consent has been removed
        if (consentCompare === 'some-rejected') {
            saveConsentConfigInCookie(true);
            window.location.reload();
            return;
        }
  
        // otherwise - if some consent has been added
        saveConsentConfigInCookie(false);
    }
  
    function setConsentBasedOnCheckboxes () {
        for (var i = 0; i < config.groups.length; i++) { 
            var group = config.groups[i];
  
            if (!!UI.checkboxes[group].prop('checked')) {
                giveConsent(group);
            }
  
            config.userConsents[group] = !!UI.checkboxes[group].prop('checked');
        }
    }
  
    function saveConsentConfigInCookie (reloadNeeded = false) {
        var configToSave = [];
  
        for (var i = 0; i < config.groups.length; i++) {
            var group = config.groups[i];
  
            if (config.userConsents[group]) {
                configToSave.push(group);
            }
        }
  
        if (configToSave.length) {
            Cookies.set(window.cnConfig.cookieName, configToSave.join(';') + '||' + config.userUUID, { expires: 180, path: window.cnConfig.path });
  
            if (config.debugMode) {
                console.log('🍪 Consent config saved in the cookie');
            }
        } else {
            Cookies.set(window.cnConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.cnConfig.path });
        }

        let dataToSave = {
            consent_id: config.userUUID,
            consent_revision: window.cnConfig.cookieName,
            consent_content: configToSave.join(';'),
            consent_timestamp: +new Date(),
            url: window.location.pathname,
            delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
        };
      
        if ('sendBeacon' in navigator) {
            const formData = $.param(dataToSave);
            const blob = new Blob(
                [formData], 
                {
                    type : 'application/x-www-form-urlencoded'
                }
            );
            navigator.sendBeacon('https://' + window.location.hostname + '/wp-json/cmp/v1/save', blob);
            
            if (reloadNeeded) {
                window.location.reload();
            }
          } else {
            $.ajax({
                url: 'https://' + window.location.hostname + '/wp-json/cmp/v1/save',
                type: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: $.param(dataToSave),
                success: function () {
                    if (reloadNeeded) {
                        window.location.reload();
                    }
                },
                fail: function () {
                    if (reloadNeeded) {
                        window.location.reload();
                    }
                }
            });
        }
    }
  
    function resetCookieConfig () {
        Cookies.set(window.cnConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.cnConfig.path });
  
        if (config.debugMode) {
            console.log('🗑 User rejected all cookies - save empty config cookie');
        }

        let dataToSave = {
            consent_id: config.userUUID,
            consent_revision: window.cnConfig.cookieName,
            consent_content: '',
            consent_timestamp: +new Date(),
            url: window.location.pathname,
            delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
        };

        let reloadNeeded = window.cnUnlocked.length > 0;
        
        if ('sendBeacon' in navigator) {
            const formData = $.param(dataToSave);
            const blob = new Blob(
                [formData], 
                {
                    type : 'application/x-www-form-urlencoded'
                }
            );
            navigator.sendBeacon('https://' + window.location.hostname + '/wp-json/cmp/v1/save', blob);

            if (reloadNeeded) {
                window.location.reload();
            }
        } else {
            $.ajax({
                url: 'https://' + window.location.hostname + '/wp-json/cmp/v1/save',
                type: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: $.param(dataToSave),
                success: function () {
                    if (reloadNeeded) {
                        window.location.reload();
                    }
                },
                fail: function () {
                    if (reloadNeeded) {
                        window.location.reload();
                    }
                }
            });
        }
    }
  
    function compareConsents () {
        var someRejected = false;
  
        for (var i = 0; i < config.groups.length; i++) {
            var group = config.groups[i];
  
            if (config.userConsents[group] && !UI.checkboxes[group].prop('checked')) {
                someRejected = true;
            }
        }
  
        if (someRejected) {
            if (config.debugMode) {
                console.log('🔄 Some consents has been rejected - website reload needed');
            }
  
            return 'some-rejected';
        }
  
        if (config.debugMode) {
            console.log('ℹ️ User not rejected any consents - website reload not needed');
        }
  
        return 'some-added-or-not-changed';
    }
  
    function getConsentStatus (type) {
        return !!config.userConsents[type];
    }
  
    function allowGoogle () {
        if (window.cnUnlocked.indexOf('google') > -1) {
            return;
        }

  
        window.cnUnlockConsentedScript('google', 'head', true);
    }

    function allowGoogleMaps () {
        if (window.cnUnlocked.indexOf('maps') > -1) {
            return;
        }
  
        window.cnUnlockGoogleMaps(true);
    }

    function generateUUID () {
        var crypto = window.crypto || window.msCrypto;
        if (crypto && crypto.randomUUID) {
            let uuid = crypto.randomUUID();
            return uuid;
        }
        if (window.Uint8Array && crypto && crypto.getRandomValues) {
            let bytes = new Uint8Array(16);
            crypto.getRandomValues(bytes);
            bytes[6] = (bytes[6] & 0x0f) | 0x40;
            bytes[8] = (bytes[8] & 0x3f) | 0x80;
            let uuid = Array.prototype.map.call(bytes, (b, i) => {
                return ((b < 16) ? '0' : '') + b.toString(16) + (((i % 2) && (i < 10) && (i > 2)) ? "-" : "");
            }).join('');
            return uuid;
        }
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (dt + Math.random()*16)%16 | 0;
            dt = Math.floor(dt/16);
            return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
        });
        return uuid;
    }
})(jQuery);